import React, { Children, cloneElement } from "react";
import {
  Datagrid,
  List,
  SimpleShowLayout,
  TextField,
  TextInput,
  SimpleForm, Edit,
  AutocompleteArrayInput,
  useTranslate,
  DateField,
  SelectInput,
  ReferenceInput,
  Filter
} from "react-admin";

import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";
import { Roles } from "../../constants/choices"
import { AccordionSection } from '@react-admin/ra-form-layout';
import { IdateInput } from "../../data/IdateTimeInput";
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
  passed: { backgroundColor: '#f9a1a1'},
  all:{paddingRight: '10px' ,paddingLeft: '10px' ,border: '1px solid'},

  ok: { backgroundColor: '#b0ffd5'},
});
export const CustomDateField = (props) => {
  const classes = useStyles();

  const isPassed = v => v < new Date().toISOString();
  return (
    <DateField {...props} className={classnames({[classes.all]:true,
      [classes.passed]: isPassed(props.record[props.source]),
      [classes.ok]: !isPassed(props.record[props.source]),

    })} />
  )
}


const FilterAdmins = (props) => {

  return (
    <Filter {...props}>
      <TextInput label=" جستجو" source="q" variant="outlined" alwaysOn />
    </Filter>
  )
};

export const AdminUserList = (props) => (
  <List {...props} perPage={1000} filters={<FilterAdmins />}>
    <Datagrid rowClick="edit" mutationMode="pessimistic" {...props} undoable={false} >
      <TextField source="name" />
      {/* <TextField source="lastName" /> */}
      <TextField source="userNumber" />
      <CustomDateField locales={"fa-IR"} source="contractEndDate" />
      <CustomDateField locales={"fa-IR"} source="healthCrdValidityDate" />
      <CustomDateField locales={"fa-IR"} source="healthEducationCertificateValidityDate" />
      {/* <TextField source="phoneNumber" /> */}
      {/* <SelectField source="role" choices={Roles} /> */}

      {/* <AutocompleteArrayInput source="roles" choices={Roles} /> */}
    </Datagrid>
  </List>
);
const Wrapper = ({ record, children }) => (
  <div className="grid grid-flow-row grid-cols-2 ">
    {Children.map(children, child => cloneElement(child, { record }))}
  </div>
);

export const AdminUserEdit = (props) => {
  const translate = useTranslate();

  return (
    <Edit {...props} >
      <SimpleForm redirect="list" submitOnEnter={false} variant="outlined" >
        <AccordionSection label="اطلاعات شخصی" fullWidth defaultExpanded className="" >
          <Wrapper>
            <TextInput label={translate('resources.adminUsers.fields.phoneNumber')} variant="outlined" source="phoneNumber" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.userNumber')} variant="outlined" source="userNumber" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.name')} variant="outlined" source="name" className="md:w-2/5" />
            {/* <TextInput label={translate('resources.adminUsers.fields.lastName')} variant="outlined" source="lastName" className="md:w-2/5" /> */}
            <TextInput label={translate('resources.adminUsers.fields.fatherNamer')} variant="outlined" source="fatherNamer" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.meliNo')} variant="outlined" source="meliNo" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.insuranceNumber')} variant="outlined" source="insuranceNumber" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.birthCertificateNumber')} variant="outlined" source="birthCertificateNumber" className="md:w-2/5" />
            <IdateInput sx={{ background: 'black' }} initialFocusedDate={new Date("1990-06-15")} label={translate('resources.adminUsers.fields.birthDate')} variant="outlined" source="birthDate" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.birthCertificateLocale')} variant="outlined" source="birthCertificateLocale" className="md:w-2/5" />
            <IdateInput label={translate('resources.adminUsers.fields.birthCertificateIssuanceDate')} initialFocusedDate={new Date("1990-06-15")} variant="outlined" source="birthCertificateIssuanceDate" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.addressPhoneNumber')} variant="outlined" source="addressPhoneNumber" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.address')} variant="outlined" source="address" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.relativesName')} variant="outlined" source="relativesName" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.relativesAddress')} variant="outlined" source="relativesAddress" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.relativesPhoneNumber')} variant="outlined" source="relativesPhoneNumber" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.numberOfChilds')} variant="outlined" source="numberOfChilds" className="md:w-2/5" />
          </Wrapper>
        </AccordionSection>
        <AccordionSection label="اطلاعات سازمانی" fullWidth className="grid grid-flow-row ">
          <Wrapper>
            <TextInput label={translate('resources.adminUsers.fields.position')} variant="outlined" source="position" className="md:w-2/5" />
            <TextInput label={translate('resources.adminUsers.fields.baseDailySalary')} variant="outlined" source="baseDailySalary" className="md:w-2/5" />
            <IdateInput label={translate('resources.adminUsers.fields.contractStartDate')} variant="outlined" source="contractStartDate" className="md:w-2/5" />
            <IdateInput label={translate('resources.adminUsers.fields.healthCrdValidityDate')} variant="outlined" source="healthCrdValidityDate" className="md:w-2/5" />
            <IdateInput label={translate('resources.adminUsers.fields.contractEndDate')} variant="outlined" source="contractEndDate" className="md:w-2/5" />
            <IdateInput label={translate('resources.adminUsers.fields.healthEducationCertificateValidityDate')} variant="outlined" source="healthEducationCertificateValidityDate" className="md:w-2/5" />
            {/* <AutocompleteArrayInput label={translate('resources.adminUsers.fields.roles')} variant="outlined" source="roles" choices={Roles} /> */}
          </Wrapper>
        </AccordionSection>

      </SimpleForm>
    </Edit >
  )
};

export const AdminUserShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="userNumber" />

      <TextField source="phoneNumber" />
      <TextField source="role" />
    </SimpleShowLayout>
  </ShowView>
);

export const AdminUserCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="name" autoComplete="off" />
    <TextInput source="userNumber" autoComplete="off" />

    <AutocompleteArrayInput source="roles" choices={Roles} />
    <TextInput source="phoneNumber" autoComplete="off" />
  </CreateView>
);
